import { type AdminPermission } from 'store/admin-admins';
import { type AdminRole } from 'store/admins';
import { type ParentCompany } from 'store/companies';
import { type AdminRoleDetails } from 'store/permissions';
import { Permission } from 'types/Administrators';
import { ContentLanguage } from 'types/general';

export const authProviders = ['google', 'cognito', 'entraId'] as const;
export type AuthProvider = (typeof authProviders)[number];

export interface CurrentUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  role: AdminRole;
  root: boolean;
  status: 'active' | 'inactive';
  creationDate: string;
  language: Uppercase<ContentLanguage>;
  parentCompany: ParentCompany | null;
  permissions: Permission[];
  adminPermissions: AdminPermission[];
  adminRole: AdminRoleDetails | null;
  permissionScopes: Array<{
    id: string;
    name: string;
  }>;
  activeEmployeesCount: number;
  companyScopeEmployeesCount: number | null;
}
